export default __webpack_public_path__ + "static/media/greatrift.b43cae30.svg";